// 智慧消息
import Log from '../view/log'
import configManagement from '../view/ResourceCenter/configManagement/MessagePush/configManagement'
import MessageOverView from '../view/MessageService/MessageOverView/MessageOverView'
import MessageTemplateManage from '../view/MessageService/MessageTemplate/MessageTemplateManage'
import MessageTemplateAdd from '../view/MessageService/MessageTemplate/MessageTemplateAdd'
import MessageTemplateModify from '../view/MessageService/MessageTemplate/MessageTemplateModify'
import MessagePushConfig from '../view/MessageService/MessagePushConfig/MessagePushConfig'
import MessagePushAdd from '../view/MessageService/MessagePushConfig/MessagePushAdd'
import MessagePushModify from '../view/MessageService/MessagePushConfig/MessagePushModify'
import MessageNav from '../view/MessageService/MessageNav'
import MessageSedManage from '../view/ResourceCenter/MessageSedManagement/MessageSedManage'
import configModify from '../view/ResourceCenter/configManagement/MessagePush/configModify'

export default [
  /* 智慧消息 */
  {
    path: '/message_over_view',
    name: 'message-over-view',
    components: {
      default: MessageNav,
      a: MessageOverView
    }
  },
  {
    path: '/message_sed_manage',
    name: 'message-sed-manage',
    components: {
      default: MessageNav,
      a: MessageSedManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/message_template_manage',
    name: 'message-template-manage',
    components: {
      default: MessageNav,
      a: MessageTemplateManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/message_template_add',
    name: 'message-template-add',
    components: {
      default: MessageNav,
      a: MessageTemplateAdd
    }
  },
  {
    path: '/message_template_modify/:id',
    name: 'message-template-modify',
    components: {
      default: MessageNav,
      a: MessageTemplateModify
    }
  },
  {
    path: '/message_push_config',
    name: 'message-push-config',
    components: {
      default: MessageNav,
      a: MessagePushConfig
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/message_push_add',
    name: 'message-push-add',
    components: {
      default: MessageNav,
      a: MessagePushAdd
    }
  },
  {
    path: '/message_push_modify/:id',
    name: 'message-push-modify',
    components: {
      default: MessageNav,
      a: MessagePushModify
    }
  },
  {
    path: '/config_management',
    name: 'config-management',
    components: {
      default: MessageNav,
      a: configManagement
    }
  },
  {
    path: '/config_modify/:id',
    name: 'config-modify',
    components: {
      default: MessageNav,
      a: configModify
    }
  },
  /* 智慧消息 */
  // 智慧消息操作日志
  {
    path: '/message_log',
    name: 'message-log',
    components: {
      default: MessageNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/MessageService.js